import React from 'react';
import './LoadingCircle.css';

const LoadingCircle = () => {
    return (
        <div className="loading-circle-container">
            <div className="loading-circle"></div>
            <div className="loading-text">Videos werden geladen...</div>
        </div>
    );
};

export default LoadingCircle;
